
import { BaseService } from "../BaseService";

export interface ISupportPlatform {
    name: string;
    platform_id: string;
}

export class HeraBaseService extends BaseService {

    constructor() {
        let baseUrl = process.env.REACT_APP_HERA_BASE_API_URL ?? "http://127.0.0.1:9401";
        super(baseUrl);
    }

}

